export default "__VITE_ASSET__BRNUVwIm__"